<script>
import moment from 'moment'
import { webSockets } from '@/api/config'

export default {
  name: 'VueMixin',
  beforeDestroy () {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    formDate (data) {
      return moment.utc(data).format('YYYY-MM-DD')
    },
    formTime (data) {
      return moment.utc(data).format('HH:mm:ss')
    },
    formatDateFilter (data) {
      return moment(data).format('YYYY-MM-DD HH:mm')
    },
    formatDateTime (data) {
      return moment.utc(data).format('YYYY-MM-DD HH:mm')
    },
    formDateTimeSec (data) {
      return moment.utc(data).format('YYYY-MM-DD HH:mm:ss')
    },
    animateAlert () {
      this.showAlert = true
      setTimeout(() => {
        this.showAlert = false
      }, 3000)
    },
    editItem (item) {
      this.modalTitle = 'Редактирование сообщения'
      this.selectedItem = item
      this.action = 'edit'
      this.showModal = true
    },
    deleteItem (item) {
      this.modalTitle = 'Удаление сообщения'
      this.selectedItem = item
      this.action = 'delete'
      //this.indexItem = this.gameChat.indexOf(item)
      this.showModal = true
    },
    blockItem (item) {
      this.modalTitle = 'Блокировка пользователя'
      this.selectedItem = item
      this.action = 'block'
      this.showModal = true
    },
    toogleDialogEmoji () {
      this.dialogHidden = !this.dialogHidden
      if (!this.dialogHidden)
        this.$nextTick(() => {
          document.addEventListener('click', this.handleOutsideClick)
        })
    },
    handleOutsideClick (event) {
      const picker = this.$refs.emojiPicker
      const trigger = document.getElementById('Emoji')
      if (!picker.contains(event.target) && !trigger.contains(event.target)) {
        this.dialogHidden = true
        document.removeEventListener('click', this.handleOutsideClick)
      }
    },
    onSelectEmoji (dataEmoji) {
      this.newMessage += dataEmoji.emoji
      this.toogleDialogEmoji()
    },
    subscribeChat (name) {
      const wsbroker = webSockets.broker
      const wsport = webSockets.port
      const client = new Paho.MQTT.Client(wsbroker, wsport, '/ws', `myclientid_${parseInt(Math.random() * 100, 10)}`)
      client.onConnectionLost = responseObject => {
        console.log(`CONNECTION LOST - ${responseObject.errorMessage}`)
      }
      client.onMessageArrived = message => {
        console.log(`RECEIVE ON!!! ${message.destinationName} PAYLOAD ${message.payloadString}`)
        this.message = JSON.parse(message.payloadString)
      }

      const options = {
        useSSL: JSON.parse(webSockets.sslStatus),
        timeout: 3,
        keepAliveInterval: 30,
        userName: webSockets.userName,
        password: webSockets.password,
        onSuccess () {
          console.log('CONNECTION SUCCESS support')
          client.subscribe(name, { qos: 1 })
        },
        onFailure (message) {
          console.log(`CONNECTION FAILURE - ${message.errorMessage}`)
        }
      }
      console.log(`CONNECT TO ${wsbroker}:${wsport}`)
      client.connect(options)
    }
  }
}
</script>
